import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.33333 21C1.59695 21 1 20.403 1 19.6667C1 18.9303 1.59695 18.3333 2.33333 18.3333H21.6667C22.403 18.3333 23 18.9303 23 19.6667C23 20.403 22.403 21 21.6667 21H2.33333ZM2.33333 14.3333C1.59695 14.3333 1 13.7364 1 13C1 12.2636 1.59695 11.6667 2.33333 11.6667H21.6667C22.403 11.6667 23 12.2636 23 13C23 13.7364 22.403 14.3333 21.6667 14.3333H2.33333ZM2.33333 7.66667C1.59695 7.66667 1 7.06971 1 6.33333C1 5.59695 1.59695 5 2.33333 5H21.6667C22.403 5 23 5.59695 23 6.33333C23 7.06971 22.403 7.66667 21.6667 7.66667H2.33333Z" }, null, -1)
  ]))]))
}
export default { render: render }